import React from "react";
import { Container, Label, IconArea } from "./Styled";

type ItemProps = {
    icon: React.ReactNode;
    label: string;
    onSelect: () => void;
  };
  
const Item: React.FunctionComponent<ItemProps> = ({onSelect, label, icon}) => {
    return (
      <Container onClick={() => onSelect()}>
        <IconArea>{icon}</IconArea>
        <Label>{label}</Label>
      </Container>
    );
  };

export default Item;